import { isEmpty, map, values } from 'lodash';
import { useSubmitSurveyAnswersMutation } from '../../../../graphQL';
import { useSurveyContext } from '../contexts/surveyContext';

type UseSaveSurveyReturn = [
  saveAnswers: () => Promise<void>,
  info: {
    isSaving: boolean;
  },
];

export const useSaveSurveyAnswersLazy = ({
  onCompleted,
  onError,
}: {
  onCompleted?: () => void;
  onError?: () => void;
}): UseSaveSurveyReturn => {
  const { answersByQuestionnaire, activeSurveyId } = useSurveyContext();

  const [submitAssessment, { loading }] = useSubmitSurveyAnswersMutation({
    onCompleted,
    onError,
  });

  const saveAnswers = async (): Promise<void> => {
    const submissions = map(answersByQuestionnaire, (answers, questionnaireKey) => {
      return {
        questionnaireKey,
        answers: values(answers),
      };
    });

    // When a user presses the back button in browser, they can re-visit /survey/finish route from the results page
    // When they do, the submission is empty, and we only want to save the assessment if there are answers to save
    if (!isEmpty(submissions)) {
      void submitAssessment({
        variables: {
          surveyId: activeSurveyId,
          submissions,
        },
      });
    }
  };

  return [saveAnswers, { isSaving: loading }];
};
